import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons/faCircleCheck';
import { defineMessages, useIntl } from 'react-intl';

// @ts-expect-error svg import
import style from './completed-step-checkmark.module.less';
import ellipse from './ellipse.svg';
// @ts-expect-error less import

const messages = defineMessages({
  dashedEllipse: {
    id: 'fU5L1T',
    defaultMessage: 'Dashed ellipse',
    description: 'Dashed ellipse alt text',
  },
});

/**
 * CompletedStepCheckmark - React component to display a dashed ellipse isComplete is false and a check if true.
 * @param {object} props
 * @param {boolean} props.isComplete
 * @returns {JSX.Element}
 */
export const CompletedStepCheckmark = ({ isComplete }) => {
  const intl = useIntl();
  if (isComplete) {
    return <FontAwesomeIcon className={style.check} icon={faCircleCheck} />;
  }
  return <img alt={intl.formatMessage(messages.dashedEllipse)} className={style['dashed-ellipse']} src={ellipse} />;
};
